/* eslint-disable typescript-sort-keys/string-enum */
enum Scale {
    C_MAJOR = "C major",
    C_SHARP_MAJOR = "C# major",
    D_MAJOR = "D major",
    D_SHARP_MAJOR = "D# major",
    E_MAJOR = "E major",
    F_MAJOR = "F major",
    F_SHARP_MAJOR = "F# major",
    G_MAJOR = "G major",
    G_SHARP_MAJOR = "G# major",
    A_MAJOR = "A major",
    A_SHARP_MAJOR = "A# major",
    B_MAJOR = "B major",
    C_MINOR = "C minor",
    C_SHARP_MINOR = "C# minor",
    D_MINOR = "D minor",
    D_SHARP_MINOR = "D# minor",
    E_MINOR = "E minor",
    F_MINOR = "F minor",
    F_SHARP_MINOR = "F# minor",
    G_MINOR = "G minor",
    G_SHARP_MINOR = "G# minor",
    A_MINOR = "A minor",
    A_SHARP_MINOR = "A# minor",
    B_MINOR = "B minor",
}

export { Scale };
